import React, { useState } from 'react';
import { DESCRIPTION_TAB } from './ProductTabsConstants';
import ProductTabsContent from './ProductTabsContent';
import ProductTabsMenu from './ProductTabsMenu';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import TabItem from '../../Types/TabItem';

interface ProductTabsProps {
  activeTab?: string;
  specification: any;
  specifications: { key: string; value: any };
  hasVariants: boolean;
  tabItems: TabItem[];
}
const StyledProductTabsContainer = styled.div`
  margin-bottom: 2.4rem;
  ${breakpoint('medium')} {
    margin-bottom: 3.6rem;
  }
  ${breakpoint('large')} {
    margin-bottom: 4rem;
  }
`;

const ProductTabsContainer = ({
  hasVariants,
  specification,
  specifications,
  tabItems
}: ProductTabsProps) => {
  const [activeTab, setActiveTab] = useState(
    tabItems.find(i => i.key?.toLowerCase() === "description") ? DESCRIPTION_TAB : ''
  );
  const { articleNumber } = useTypedSelector((state) => state.buyButton);
  return (
    <StyledProductTabsContainer>
      <ProductTabsMenu
        tabItems={tabItems}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        specifications={
          articleNumber && articleNumber.length > 0 && specifications
            ? specifications[articleNumber]
            : specification
        }
      />
      <ProductTabsContent
        tabItems={tabItems}
        activeTab={activeTab}
        showSpecificationsDefaultText={
          hasVariants && (!articleNumber || articleNumber.length < 1)
        }
        specifications={
          articleNumber && articleNumber.length > 0 && specifications
            ? specifications[articleNumber]
            : specification
        }
      />
    </StyledProductTabsContainer>
  );
};

export default ProductTabsContainer;
